import React from "react";
import { ShieldCheck, ShieldAlert, ShieldX } from "lucide-react";

/**
 * Small inline badge showing the 0-100 reliability score next to a username.
 * Color-codes by tier:  ≥80 green · 60-79 amber · 40-59 orange · <40 red.
 */
export default function ReliabilityBadge({ score, flagged = false, size = "sm", testId }) {
  if (score === null || score === undefined) return null;
  const s = Number(score);
  const tier = s >= 80
    ? { cls: "text-[#00FF87] border-[#00FF87]/50 bg-[#00FF87]/10", Icon: ShieldCheck, label: "ELITE" }
    : s >= 60
      ? { cls: "text-[#7C3AED] border-[#7C3AED]/45 bg-[#7C3AED]/10", Icon: ShieldCheck, label: "OK" }
      : s >= 50
        ? { cls: "text-[#FFCC00] border-[#FFCC00]/50 bg-[#FFCC00]/10", Icon: ShieldAlert, label: "WATCH" }
        : { cls: "text-[#E11D48] border-[#E11D48]/55 bg-[#E11D48]/10", Icon: ShieldX, label: "LOW" };
  const dims = size === "lg"
    ? "px-2.5 py-1 text-xs"
    : size === "md"
      ? "px-2 py-0.5 text-[11px]"
      : "px-1.5 py-0.5 text-[10px]";
  const iconSize = size === "lg" ? "w-3.5 h-3.5" : "w-3 h-3";
  return (
    <span
      data-testid={testId}
      title={`Reliability ${s}/100${flagged ? " · flagged for review" : ""}`}
      className={`inline-flex items-center gap-1 font-mono uppercase tracking-[0.15em] border ${tier.cls} ${dims}`}
    >
      <tier.Icon className={iconSize} aria-hidden />
      <span className="tabular-nums font-bold">{s}</span>
      {flagged && <span className="text-[9px] opacity-80">!</span>}
    </span>
  );
}
